import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { nameof } from 'ts-simple-nameof';
import { DialogService } from '../dialog/dialog.service';
import { DialogSubscriptionComponent } from '../dialog/dialog-subscription.component';
import { ReflectionService } from '../shared/utilities/reflection.service';
import { TextEditComponent } from './text-edit/text-edit.component';
import { ComponentText, TextService } from './text.service';

@Component({
    selector: 'app-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class TextComponent extends DialogSubscriptionComponent implements OnInit, OnDestroy {
    @Input() alias: string;
    @Input() formConfigurationAlias: string = 'igrade';
    @Input() interpolationObject: any;
    doneLoading: boolean = false;
    text: ComponentText;
    over: boolean;
    isEmpty: boolean;
    toolTip: string;
    private sub$: Subscription;

    constructor(
        private service: TextService,
        private dialogService: DialogService<ComponentText>,
        private reflection: ReflectionService
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.alias && this.formConfigurationAlias) {
            this.service.text(this.alias, this.formConfigurationAlias).subscribe(
                (text) => {
                    this.text = text;
                    this.toolTip = `Edit this text area belonging to ${this.text.formConfigurationAlias} and named ${this.text.alias}`;
                    this.interpolate();
                    this.isEmpty = !this.reflection.isNotNullOrEmpty(this.text?.text);
                    this.doneLoading = true;
                },
                () => {}
            );
            this.sub$ = this.service.enableDisableResponse.subscribe((v: boolean) => {
                if (!this.text) {
                    return;
                }
                this.text.mayEdit = v;
            });
        }
    }
    ngOnDestroy() {
        if (this.sub$) {
            this.sub$.unsubscribe();
        }
    }

    interpolate(): void {

        if (this.text) {
            //console.log(this.interpolationObject);
            //console.log(this.text);
            this.text.interpolatedText = this.reflection.stringDataMerge(this.interpolationObject, this.text.text);
        }
    }

    edit() {
        if (this.text) {
            const dialog = this.dialogService.show(this.text, {
                uniqueId: this.dialogService.generateUniqueId(
                    this.text,
                    nameof<ComponentText>((m) => m.id),
                    'TextEditComponent'
                ),
                dialogAlias: 'TextEditComponent',
                title: this.formConfigurationAlias + ': ' + this.alias,
                component: TextEditComponent
            });
            this.addSubscription(
                this.dialogService.response.subscribe((next) => {
                    if (next.dialogAlias === 'TextEditComponent') {
                        if (this.text.id === next.payload.id) {
                            this.text = next.payload;
                        }
                        this.interpolate();
                        this.isEmpty = !this.reflection.isNotNullOrEmpty(this.text?.text);
                    }
                }),
                dialog
            );
        }
    }

    mouseOver() {
        this.over = true;
    }

    mouseOut() {
        this.over = false;
    }
}
